import { PaymentRequestDetailFieldsFragment } from 'generated/resources/graphql'

import formatCurrency from 'modules/core/lib/formatCurrency'
import i18n from 'modules/core/lib/i18n'
import { ResourceHeadersPropsWithActions } from 'modules/core/lib/navigation/types'

type StatusColor = 'neutral' | 'info' | 'positive' | 'warning'

const getStatusColor = (status: string): StatusColor => {
  const statusColorMap: Record<string, StatusColor> = {
    init: 'neutral',
    in_progress: 'info',
    partially_paid: 'warning',
    paid: 'positive',
  }
  return statusColorMap[status] ?? 'neutral'
}

const getStatusLabel = (status: string): string => {
  const statusLabelMap: Record<string, string> = {
    init: i18n.t('banking.paymentRequests.status.init'),
    in_progress: i18n.t('banking.paymentRequests.status.inProgress'),
    partially_paid: i18n.t('banking.paymentRequests.status.partiallyPaid'),
    paid: i18n.t('banking.paymentRequests.status.paid'),
  }
  return statusLabelMap[status] ?? status
}

export const buildPaymentRequestHeaderComponentProps = (
  paymentRequest: PaymentRequestDetailFieldsFragment
): ResourceHeadersPropsWithActions => {
  return {
    title: paymentRequest.label ?? '',
    status: {
      label: '',
      text: getStatusLabel(paymentRequest.status),
      variant: getStatusColor(paymentRequest.status),
    },
    metadata: [
      {
        label: i18n.t('banking.paymentRequests.detail.totalAmount'),
        value: {
          type: 'text',
          content: formatCurrency(paymentRequest.amountCents, paymentRequest.currency),
        },
      },
      {
        label: i18n.t('banking.paymentRequests.detail.requester'),
        value: {
          type: 'text',
          content: paymentRequest.requester?.access?.fullName ?? '-',
        },
      },
      ...(paymentRequest.dueDate
        ? [
            {
              label: i18n.t('banking.paymentRequests.detail.dueDate'),
              value: {
                type: 'text' as const,
                content: new Date(paymentRequest.dueDate).toLocaleDateString(),
              },
            },
          ]
        : []),
    ],
  }
}
